
(function() {
  var result = { translations: { "bn": { "i18n": { "duration": { "seconds": "{{ seconds }}\u09B8\u09C7\u0995", "minutes": "{{ minutes }}\u09AE\u09BF\u09A8\u09BF\u099F", "hours": "{{ hours }}\u0998\u09A8\u09CD\u099F\u09BE", "hoursAndMinutes": "{{ hours }}\u0998\u09A8\u09CD\u099F\u09BE {{ minutes }}\u09AE\u09BF\u09A8\u09BF\u099F", "days": "{{ days }}\u09A6\u09BF\u09A8\xA0", "shortForm": { "seconds": "{{ seconds }}\u09B8\u09C7", "minutes": "{{ minutes }}\u09AE\u09BF\xA0", "hours": "{{ hours }}\u0998", "days": "{{ days }}\u09A6\u09BF\xA0", "hoursAndMinutes": "{{ hours }}\u0998 {{ minutes }}\u09AE\u09BF" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}}{{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}},\u098F\u0995\u09CD\u09B8\u099F.{{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "bn": "static-7.807"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.807",
    "ar-eg": "static-7.807",
    "bg": "static-7.807",
    "bn": "static-7.807",
    "ca-es": "static-7.807",
    "cs": "static-7.807",
    "da": "static-7.807",
    "de": "static-7.807",
    "el": "static-7.807",
    "en-gb": "static-7.807",
    "en": "static-7.807",
    "es-mx": "static-7.807",
    "es": "static-7.807",
    "fi": "static-7.807",
    "fr-ca": "static-7.807",
    "fr": "static-7.807",
    "he-il": "static-7.807",
    "hr": "static-7.807",
    "hu": "static-7.807",
    "id": "static-7.807",
    "it": "static-7.807",
    "ja": "static-7.807",
    "ko": "static-7.807",
    "lt": "static-7.807",
    "ms": "static-7.807",
    "nl": "static-7.807",
    "no": "static-7.807",
    "pl": "static-7.807",
    "pt-br": "static-7.807",
    "pt-pt": "static-7.807",
    "ro": "static-7.807",
    "ru": "static-7.807",
    "sk": "static-7.807",
    "sl": "static-7.807",
    "sv": "static-7.807",
    "th": "static-7.807",
    "tl": "static-7.807",
    "tr": "static-7.807",
    "uk": "static-7.807",
    "vi": "static-7.807",
    "x-pseudo": "static-7.807",
    "zh-cn": "static-7.807",
    "zh-hk": "static-7.807",
    "zh-tw": "static-7.807"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:bn', {version: 'static-7.807'}); }
})();


